export default function ChatUserAvatar() {
  return (
      <span
          className="flex-shrink-0 inline-flex items-center justify-center h-[2.375rem] w-[2.375rem] rounded-full bg-gray-600">
        <span className="text-sm font-medium text-white leading-none">AZ</span>
      </span>
  )
}